module.exports = __webpack_public_path__ + "media/images/top/img_tab_dokanto-76c38b44f8ae1edf840c3654cf731bcd.png";